export const mockData = {
  hero: {
    tagline: 'Stories wrapped in light and promises',
    title: 'Every Frame, A Vow',
    subtitle: 'A Cinematic Wedding Story Studio',
    cta: 'Book Your Date'
  },
  about: {
    title: 'Where Veils Meet Forever',
    subtitle: 'About Ever After',
    description: 'At Ever After by Shashank, we believe every wedding is a unique love story waiting to be told. With a cinematic approach to photography, we capture not just moments, but emotions, promises, and the beginning of your forever. Our style blends timeless elegance with contemporary artistry, creating images that will be cherished for generations.',
    highlights: [
      { number: '500+', label: 'Weddings Captured' },
      { number: '50+', label: 'Cities Covered' },
      { number: '10+', label: 'Years Experience' },
      { number: '100%', label: 'Client Satisfaction' }
    ]
  },
  services: {
    title: 'Our Services',
    subtitle: 'Crafting Your Perfect Day',
    items: [
      {
        id: 1,
        icon: 'Camera',
        title: 'Wedding Photography',
        description: 'Comprehensive coverage of your special day with cinematic storytelling and artistic compositions.'
      },
      {
        id: 2,
        icon: 'Video',
        title: 'Cinematic Films',
        description: 'Beautifully crafted wedding films that capture the emotion and essence of your celebration.'
      },
      {
        id: 3,
        icon: 'Users',
        title: 'Pre-Wedding Shoots',
        description: 'Romantic pre-wedding sessions at stunning locations that showcase your unique love story.'
      },
      {
        id: 4,
        icon: 'Heart',
        title: 'Destination Weddings',
        description: 'Full-service coverage for destination weddings anywhere in the world.'
      }
    ]
  },
  portfolio: {
    title: 'Our Work',
    subtitle: 'Moments That Last Forever',
    images: [
      { id: 1, url: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80', title: 'Priya & Rahul' },
      { id: 2, url: 'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=800&q=80', title: 'Aisha & Arjun' },
      { id: 3, url: 'https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=800&q=80', title: 'Meera & Rohan' },
      { id: 4, url: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=800&q=80', title: 'Diya & Karan' },
      { id: 5, url: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=800&q=80', title: 'Ananya & Vikram' },
      { id: 6, url: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800&q=80', title: 'Sana & Aditya' }
    ]
  },
  testimonials: {
    title: 'Love Notes',
    subtitle: 'What Our Couples Say',
    reviews: [
      {
        id: 1,
        name: 'Priya & Rahul',
        wedding: 'Udaipur, December 2024',
        text: 'Shashank captured our wedding so beautifully! Every photo tells a story and we can relive our special day through his lens. His attention to detail and artistic vision is unmatched.',
        rating: 5
      },
      {
        id: 2,
        name: 'Aisha & Arjun',
        wedding: 'Jaipur, November 2024',
        text: 'Working with Ever After was the best decision we made. The team was professional, creative, and made us feel so comfortable. Our photos are absolutely stunning!',
        rating: 5
      },
      {
        id: 3,
        name: 'Meera & Rohan',
        wedding: 'Goa, October 2024',
        text: 'Shashank has an incredible eye for capturing emotions. Looking at our wedding album brings tears to our eyes every single time. Thank you for preserving our memories so beautifully.',
        rating: 5
      }
    ]
  },
  contact: {
    title: 'Begin Your Story',
    subtitle: 'Let\'s Create Magic Together',
    description: 'Every love story deserves to be told beautifully. Reach out to us and let\'s discuss how we can capture your special moments.',
    phone: '+91 98765 43210',
    email: 'hello@everafterbyshashank.com',
    social: {
      instagram: 'https://instagram.com/everafterbyshashank',
      facebook: 'https://facebook.com/everafterbyshashank',
      youtube: 'https://youtube.com/everafterbyshashank'
    }
  }
};
